<template>
  <el-radio-group v-bind="$attrs"
                  v-on="$listeners">
    <el-radio :label="0">{{ 0 | status }}</el-radio>
    <el-radio :label="1">{{ 1 | status }}</el-radio>
  </el-radio-group>
</template>

<script>
  export default {
    name: 'EnableSelect'
  }
</script>
